import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StdLegalInsService {

  env = environment;
  constructor(private http: HttpClient) { }


    GetStdLegalInsState(data:any) {
    return this.http.post(this.env.webApiUrl + 'api/StdLegalInsurance/GetStdLegalInsStateDetails', data );
  }
  RemoveStdLegalInsAlert(){
    return this.http.post(this.env.webApiUrl + 'api/StdLegalInsurance/RemoveStdLegalInsMessageId', null);
  }

  
}